export interface FaqItem {
  question: string;
  answer: string;
}

export interface ProjectFaqItem extends FaqItem {
  project: string;
}

export enum FaqProject {
  retail = 'retail',
  led = 'led',
  evc = 'evc',
}

export type Faq = {
  title: string;
  project: FaqProject;
  items: FaqItem[];
};

export type Partner = {
  title: string;
  link: string;
  description: string;
  desktopImage: string;
  mobileImage: string;
};

export type LedTerm = {
  title?: string;
  content: string;
};

export type StateTax = {
  name: string;
  usps: string;
  tax: number;
};

export interface CmsServiceInterface {
  getFAQs(): Promise<Faq[]>;
  getAboutUsFAQs(): Promise<FaqItem[]>;
  getPartners(): Promise<Partner[]>;
  getStateTaxes(): Promise<StateTax[]>;
  getLedTerms(): Promise<LedTerm[]>;
}
